function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { assign, setup, fromPromise } from 'xstate';
// 머신 setup
export var curriculumMachine = setup({
    types: {
        context: {},
        events: {},
        input: {}
    },
    actors: {
        parseCurriculumMarkdownActor: fromPromise(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var input;
                return _ts_generator(this, function(_state) {
                    input = param.input;
                    if (!input.parseFunction) throw new Error("parseFunction is not provided");
                    return [
                        2,
                        input.parseFunction(input.markdownContent)
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()),
        addSectionActor: fromPromise(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var input, sectionsFromStore, newSection;
                return _ts_generator(this, function(_state) {
                    input = param.input;
                    console.log('[machine.addSectionActor] Actor called. Input title:', input.title, 'doZustandAddSection exists:', !!input.doZustandAddSection);
                    if (!input.title.trim()) {
                        throw new Error("Section title cannot be empty.");
                    }
                    sectionsFromStore = input.getSectionsFromStore ? input.getSectionsFromStore() : [];
                    newSection = {
                        id: "s_actor_".concat(Date.now()),
                        title: input.title.trim(),
                        lessons: [],
                        order: sectionsFromStore.length + 1
                    };
                    if (input.doZustandAddSection) {
                        console.log('[machine.addSectionActor] Calling doZustandAddSection with new section:', newSection);
                        input.doZustandAddSection(newSection);
                    } else {
                        console.warn('[machine.addSectionActor] doZustandAddSection function was not provided!');
                    }
                    return [
                        2,
                        newSection
                    ];
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }())
    },
    actions: {
        logContext: function(param) {
            var context = param.context;
            console.log("Current machine context:", JSON.parse(JSON.stringify(context)));
        },
        notifyError: function(param) {
            var context = param.context, event = param.event;
            var _event_error, _context_dependencies;
            var errorMessage = ((_event_error = event.error) === null || _event_error === void 0 ? void 0 : _event_error.message) || context.errorMessage || "An unknown error occurred.";
            if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.toastError) {
                context.dependencies.toastError(errorMessage);
            } else {
                console.error("Error:", errorMessage);
            }
        },
        clearEditingStates: assign({
            isAddingSection: false,
            newSectionTitleField: '',
            editingSectionId: null,
            editingSectionTitleCache: '',
            addingLessonToSectionId: null,
            newLessonTitleField: '',
            editingLessonId: null,
            editingLessonSectionId: null,
            editingLessonTitleCache: ''
        }),
        applyLoadFromStoreSnapshot: assign({
            sections: function(param) {
                var context = param.context, event = param.event;
                if (event.type !== 'LOAD_FROM_STORE') {
                    return context.sections;
                }
                console.log('[curriculumMachine] LOAD_FROM_STORE: event.sections:', JSON.parse(JSON.stringify(event.sections)));
                return event.sections;
            },
            selectedLesson: function(param) {
                var context = param.context, event = param.event;
                return event.type === 'LOAD_FROM_STORE' ? event.selectedLesson : context.selectedLesson;
            },
            isCurriculumDirty: function(param) {
                var context = param.context, event = param.event;
                return event.type === 'LOAD_FROM_STORE' ? event.dirty : context.isCurriculumDirty;
            }
        }),
        resetLectureFormDirtyAfterLoad: assign({
            lectureFormDirty: function(param) {
                var context = param.context, event = param.event;
                return event.type === 'LOAD_FROM_STORE' ? false : context.lectureFormDirty;
            }
        }),
        notifyCurriculumUpdateFromStore: function(param) {
            var context = param.context, event = param.event;
            var _context_dependencies;
            if (event.type !== 'LOAD_FROM_STORE') {
                return;
            }
            if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.onCurriculumUpdated) {
                context.dependencies.onCurriculumUpdated({
                    isDirty: context.isCurriculumDirty || context.lectureFormDirty,
                    sections: context.sections,
                    courseId: context.courseId,
                    lectureFormDirty: context.lectureFormDirty
                });
            }
        }
    },
    guards: {
        isNewSectionTitleValid: function(param) {
            var context = param.context;
            return !!context.newSectionTitleField.trim();
        },
        isEditingSectionTitleValid: function(param) {
            var context = param.context;
            return !!context.editingSectionTitleCache.trim();
        },
        isNewLessonTitleValid: function(param) {
            var context = param.context;
            return !!context.newLessonTitleField.trim();
        },
        isEditingLessonTitleValid: function(param) {
            var context = param.context;
            return !!context.editingLessonTitleCache.trim();
        }
    }
}).createMachine({
    id: 'curriculumManager',
    context: function(param) {
        var input = param.input;
        return {
            courseId: input.courseId,
            sections: [],
            selectedLesson: null,
            isAddingSection: false,
            newSectionTitleField: '',
            editingSectionId: null,
            editingSectionTitleCache: '',
            addingLessonToSectionId: null,
            newLessonTitleField: '',
            editingLessonId: null,
            editingLessonSectionId: null,
            editingLessonTitleCache: '',
            isCurriculumDirty: false,
            lectureFormDirty: false,
            importedMarkdownContentForCurriculum: null,
            parsedSectionsForImport: null,
            errorMessage: null,
            dependencies: input.dependencies
        };
    },
    initial: 'initializing',
    states: {
        initializing: {
            on: {
                INITIALIZE_CURRICULUM: {
                    actions: assign({
                        sections: function(param) {
                            var event = param.event;
                            console.log('[curriculumMachine] INITIALIZE_CURRICULUM: event.initialSections:', event.initialSections);
                            return event.initialSections || [];
                        },
                        courseId: function(param) {
                            var event = param.event;
                            return event.courseId;
                        },
                        isCurriculumDirty: false,
                        lectureFormDirty: false,
                        selectedLesson: null
                    }),
                    target: 'idle'
                },
                LOAD_FROM_STORE: {
                    actions: [
                        'applyLoadFromStoreSnapshot',
                        'resetLectureFormDirtyAfterLoad',
                        'notifyCurriculumUpdateFromStore'
                    ],
                    target: 'idle'
                }
            }
        },
        idle: {
            entry: [
                'clearEditingStates',
                'logContext'
            ],
            on: {
                MARK_AS_MODIFIED: {
                    actions: [
                        assign({
                            isCurriculumDirty: true
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies;
                            if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.onCurriculumUpdated) {
                                context.dependencies.onCurriculumUpdated({
                                    isDirty: true,
                                    sections: context.sections,
                                    courseId: context.courseId,
                                    lectureFormDirty: context.lectureFormDirty
                                });
                            }
                        }
                    ]
                },
                SET_LECTURE_FORM_DIRTY: {
                    actions: [
                        assign({
                            lectureFormDirty: function(param) {
                                var event = param.event;
                                return event.isDirty;
                            }
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies;
                            if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.onCurriculumUpdated) {
                                context.dependencies.onCurriculumUpdated({
                                    isDirty: context.isCurriculumDirty || context.lectureFormDirty,
                                    sections: context.sections,
                                    courseId: context.courseId,
                                    lectureFormDirty: context.lectureFormDirty
                                });
                            }
                        }
                    ]
                },
                // 섹션 관리
                TOGGLE_ADD_SECTION_FORM: {
                    actions: assign(function(param) {
                        var context = param.context, event = param.event;
                        return {
                            isAddingSection: !context.isAddingSection,
                            newSectionTitleField: '',
                            editingSectionId: null,
                            addingLessonToSectionId: null
                        };
                    })
                },
                SET_NEW_SECTION_TITLE: {
                    actions: assign({
                        newSectionTitleField: function(param) {
                            var event = param.event;
                            return event.title;
                        }
                    })
                },
                SUBMIT_ADD_SECTION: {
                    guard: 'isNewSectionTitleValid',
                    target: 'addingSection'
                },
                START_EDIT_SECTION: {
                    actions: assign({
                        editingSectionId: function(param) {
                            var event = param.event;
                            return event.sectionId;
                        },
                        editingSectionTitleCache: function(param) {
                            var context = param.context, event = param.event;
                            var _context_sections_find;
                            return ((_context_sections_find = context.sections.find(function(s) {
                                return s.id === event.sectionId;
                            })) === null || _context_sections_find === void 0 ? void 0 : _context_sections_find.title) || '';
                        },
                        isAddingSection: false,
                        addingLessonToSectionId: null
                    })
                },
                SET_EDITING_SECTION_TITLE: {
                    actions: assign({
                        editingSectionTitleCache: function(param) {
                            var event = param.event;
                            return event.title;
                        }
                    })
                },
                SUBMIT_EDIT_SECTION: {
                    guard: 'isEditingSectionTitleValid',
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies;
                                (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.updateSectionTitle(event.sectionId, context.editingSectionTitleCache);
                                return context.sections.map(function(s) {
                                    return s.id === event.sectionId ? _object_spread_props(_object_spread({}, s), {
                                        title: context.editingSectionTitleCache
                                    }) : s;
                                });
                            },
                            editingSectionId: null,
                            editingSectionTitleCache: '',
                            isCurriculumDirty: true
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies_toastSuccess, _context_dependencies;
                            return (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastSuccess = _context_dependencies.toastSuccess) === null || _context_dependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_toastSuccess.call(_context_dependencies, '섹션 제목이 수정되었습니다.');
                        }
                    ],
                    target: 'idle',
                    reenter: true
                },
                CANCEL_EDIT_SECTION: {
                    actions: assign({
                        editingSectionId: null,
                        editingSectionTitleCache: ''
                    })
                },
                DELETE_SECTION: {
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies_confirmAction, _context_dependencies;
                                if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_confirmAction = _context_dependencies.confirmAction) === null || _context_dependencies_confirmAction === void 0 ? void 0 : _context_dependencies_confirmAction.call(_context_dependencies, '정말로 이 섹션을 삭제하시겠습니까? 포함된 모든 강의도 함께 삭제됩니다.')) {
                                    var _context_dependencies1;
                                    (_context_dependencies1 = context.dependencies) === null || _context_dependencies1 === void 0 ? void 0 : _context_dependencies1.deleteSection(event.sectionId);
                                    return context.sections.filter(function(s) {
                                        return s.id !== event.sectionId;
                                    });
                                }
                                return context.sections;
                            },
                            isCurriculumDirty: true,
                            selectedLesson: function(param) {
                                var context = param.context, event = param.event;
                                var _context_selectedLesson;
                                return ((_context_selectedLesson = context.selectedLesson) === null || _context_selectedLesson === void 0 ? void 0 : _context_selectedLesson.sectionId) === event.sectionId ? null : context.selectedLesson;
                            }
                        }),
                        function(param) {
                            var context = param.context, event = param.event;
                            var _context_dependencies;
                            var sectionExists = context.sections.some(function(s) {
                                return s.id === event.sectionId;
                            });
                            if (!sectionExists && ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.toastSuccess)) context.dependencies.toastSuccess('섹션이 삭제되었습니다.');
                        }
                    ],
                    target: 'idle',
                    reenter: true
                },
                MOVE_SECTION: {
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies;
                                (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.moveSection(event.dragIndex, event.hoverIndex);
                                var newSections = Array.from(context.sections);
                                var _newSections_splice = _sliced_to_array(newSections.splice(event.dragIndex, 1), 1), movedSection = _newSections_splice[0];
                                newSections.splice(event.hoverIndex, 0, movedSection);
                                return newSections.map(function(section, index) {
                                    return _object_spread_props(_object_spread({}, section), {
                                        order: index + 1
                                    });
                                });
                            },
                            isCurriculumDirty: true
                        })
                    ]
                },
                // 강의 관련
                SELECT_LESSON: {
                    actions: [
                        assign({
                            selectedLesson: function(param) {
                                var event = param.event;
                                return event.lessonId ? {
                                    sectionId: event.sectionId,
                                    lessonId: event.lessonId
                                } : null;
                            },
                            lectureFormDirty: false
                        }),
                        function(param) {
                            var context = param.context, event = param.event;
                            var _context_dependencies;
                            return (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.selectLesson(event.sectionId, event.lessonId);
                        },
                        'logContext'
                    ]
                },
                TOGGLE_ADD_LESSON_FORM: {
                    actions: assign(function(param) {
                        var context = param.context, event = param.event;
                        return {
                            addingLessonToSectionId: context.addingLessonToSectionId === event.sectionId ? null : event.sectionId,
                            newLessonTitleField: '',
                            isAddingSection: false,
                            editingSectionId: null
                        };
                    })
                },
                SET_NEW_LESSON_TITLE: {
                    actions: assign({
                        newLessonTitleField: function(param) {
                            var event = param.event;
                            return event.title;
                        }
                    })
                },
                SUBMIT_ADD_LESSON: {
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies;
                                // 빈 제목일 경우 기본값 설정
                                var lessonTitle = context.newLessonTitleField.trim() || "새 강의 ".concat(new Date().toLocaleTimeString('ko-KR', {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit'
                                }));
                                var newLesson = (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.addLesson(event.sectionId, lessonTitle);
                                if (!newLesson) return context.sections;
                                return context.sections.map(function(section) {
                                    return section.id === event.sectionId ? _object_spread_props(_object_spread({}, section), {
                                        lessons: _to_consumable_array(section.lessons).concat([
                                            newLesson
                                        ])
                                    }) : section;
                                });
                            },
                            addingLessonToSectionId: null,
                            newLessonTitleField: '',
                            isCurriculumDirty: true
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies_toastSuccess, _context_dependencies;
                            return (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastSuccess = _context_dependencies.toastSuccess) === null || _context_dependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_toastSuccess.call(_context_dependencies, '강의가 추가되었습니다.');
                        }
                    ],
                    target: 'idle',
                    reenter: true
                },
                START_EDIT_LESSON: {
                    actions: assign({
                        editingLessonSectionId: function(param) {
                            var event = param.event;
                            return event.sectionId;
                        },
                        editingLessonId: function(param) {
                            var event = param.event;
                            return event.lessonId;
                        },
                        editingLessonTitleCache: function(param) {
                            var context = param.context, event = param.event;
                            var _context_sections_find_lessons_find, _context_sections_find;
                            return ((_context_sections_find = context.sections.find(function(s) {
                                return s.id === event.sectionId;
                            })) === null || _context_sections_find === void 0 ? void 0 : (_context_sections_find_lessons_find = _context_sections_find.lessons.find(function(l) {
                                return l.id === event.lessonId;
                            })) === null || _context_sections_find_lessons_find === void 0 ? void 0 : _context_sections_find_lessons_find.title) || '';
                        },
                        isAddingSection: false,
                        editingSectionId: null,
                        addingLessonToSectionId: null
                    })
                },
                SET_EDITING_LESSON_TITLE: {
                    actions: assign({
                        editingLessonTitleCache: function(param) {
                            var event = param.event;
                            return event.title;
                        }
                    })
                },
                SUBMIT_EDIT_LESSON: {
                    guard: 'isEditingLessonTitleValid',
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies;
                                (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.updateLessonTitle(event.sectionId, event.lessonId, context.editingLessonTitleCache);
                                return context.sections.map(function(s) {
                                    return s.id === event.sectionId ? _object_spread_props(_object_spread({}, s), {
                                        lessons: s.lessons.map(function(l) {
                                            return l.id === event.lessonId ? _object_spread_props(_object_spread({}, l), {
                                                title: context.editingLessonTitleCache
                                            }) : l;
                                        })
                                    }) : s;
                                });
                            },
                            editingLessonId: null,
                            editingLessonSectionId: null,
                            editingLessonTitleCache: '',
                            isCurriculumDirty: true
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies_toastSuccess, _context_dependencies;
                            return (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastSuccess = _context_dependencies.toastSuccess) === null || _context_dependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_toastSuccess.call(_context_dependencies, '강의 제목이 수정되었습니다.');
                        }
                    ],
                    target: 'idle',
                    reenter: true
                },
                CANCEL_EDIT_LESSON: {
                    actions: assign({
                        editingLessonId: null,
                        editingLessonSectionId: null,
                        editingLessonTitleCache: ''
                    })
                },
                DELETE_LESSON: {
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies_confirmAction, _context_dependencies;
                                if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_confirmAction = _context_dependencies.confirmAction) === null || _context_dependencies_confirmAction === void 0 ? void 0 : _context_dependencies_confirmAction.call(_context_dependencies, '정말로 이 강의를 삭제하시겠습니까?')) {
                                    var _context_dependencies1;
                                    (_context_dependencies1 = context.dependencies) === null || _context_dependencies1 === void 0 ? void 0 : _context_dependencies1.deleteLesson(event.sectionId, event.lessonId);
                                    return context.sections.map(function(s) {
                                        return s.id === event.sectionId ? _object_spread_props(_object_spread({}, s), {
                                            lessons: s.lessons.filter(function(l) {
                                                return l.id !== event.lessonId;
                                            })
                                        }) : s;
                                    });
                                }
                                return context.sections;
                            },
                            isCurriculumDirty: true,
                            selectedLesson: function(param) {
                                var context = param.context, event = param.event;
                                var _context_selectedLesson;
                                return ((_context_selectedLesson = context.selectedLesson) === null || _context_selectedLesson === void 0 ? void 0 : _context_selectedLesson.lessonId) === event.lessonId ? null : context.selectedLesson;
                            }
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies_toastSuccess, _context_dependencies;
                            return (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastSuccess = _context_dependencies.toastSuccess) === null || _context_dependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_toastSuccess.call(_context_dependencies, '강의가 삭제되었습니다.');
                        }
                    ],
                    target: 'idle',
                    reenter: true
                },
                MOVE_LESSON: {
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context, event = param.event;
                                var _context_dependencies;
                                (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.moveLesson(event.sectionId, event.dragIndex, event.hoverIndex);
                                var newSections = context.sections.map(function(section) {
                                    if (section.id === event.sectionId) {
                                        var newLessons = Array.from(section.lessons);
                                        var _newLessons_splice = _sliced_to_array(newLessons.splice(event.dragIndex, 1), 1), movedLesson = _newLessons_splice[0];
                                        newLessons.splice(event.hoverIndex, 0, movedLesson);
                                        return _object_spread_props(_object_spread({}, section), {
                                            lessons: newLessons.map(function(lesson, index) {
                                                return _object_spread_props(_object_spread({}, lesson), {
                                                    order: index + 1
                                                });
                                            })
                                        });
                                    }
                                    return section;
                                });
                                return newSections;
                            },
                            isCurriculumDirty: true
                        })
                    ]
                },
                // 전체 커리큘럼 임포트
                IMPORT_CURRICULUM_MARKDOWN_FILE: {
                    actions: assign({
                        importedMarkdownContentForCurriculum: function(param) {
                            var event = param.event;
                            return event.fileContent;
                        }
                    }),
                    target: 'parsingCurriculumMarkdown'
                }
            }
        },
        addingSection: {
            invoke: {
                id: 'addSectionActor',
                src: 'addSectionActor',
                input: function(param) {
                    var context = param.context;
                    var _context_dependencies, _context_dependencies1;
                    return {
                        title: context.newSectionTitleField,
                        getSectionsFromStore: (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.getSectionsFromStore,
                        doZustandAddSection: (_context_dependencies1 = context.dependencies) === null || _context_dependencies1 === void 0 ? void 0 : _context_dependencies1.zustandAddSection
                    };
                },
                onDone: {
                    target: 'idle',
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context;
                                var _context_dependencies_getSectionsFromStore, _context_dependencies;
                                var _context_dependencies_getSectionsFromStore1;
                                return (_context_dependencies_getSectionsFromStore1 = (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_getSectionsFromStore = _context_dependencies.getSectionsFromStore) === null || _context_dependencies_getSectionsFromStore === void 0 ? void 0 : _context_dependencies_getSectionsFromStore.call(_context_dependencies)) !== null && _context_dependencies_getSectionsFromStore1 !== void 0 ? _context_dependencies_getSectionsFromStore1 : context.sections;
                            },
                            isAddingSection: false,
                            newSectionTitleField: '',
                            isCurriculumDirty: true
                        }),
                        function(param) {
                            var context = param.context, event = param.event;
                            var _context_dependencies_toastSuccess, _context_dependencies;
                            return (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastSuccess = _context_dependencies.toastSuccess) === null || _context_dependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_toastSuccess.call(_context_dependencies, "섹션 '".concat(event.output.title, "'이(가) 추가되었습니다."));
                        },
                        function(param) {
                            var context = param.context;
                            var _context_dependencies;
                            if ((_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : _context_dependencies.onCurriculumUpdated) {
                                context.dependencies.onCurriculumUpdated({
                                    isDirty: context.isCurriculumDirty || context.lectureFormDirty,
                                    sections: context.sections,
                                    courseId: context.courseId,
                                    lectureFormDirty: context.lectureFormDirty
                                });
                            }
                        }
                    ],
                    reenter: true
                },
                onError: {
                    target: 'idle',
                    actions: [
                        assign({
                            errorMessage: function(param) {
                                var event = param.event;
                                var _event_error;
                                return ((_event_error = event.error) === null || _event_error === void 0 ? void 0 : _event_error.message) || '섹션 추가 중 오류 발생';
                            }
                        }),
                        'notifyError'
                    ],
                    reenter: true
                }
            }
        },
        parsingCurriculumMarkdown: {
            invoke: {
                id: 'parseCurriculumMarkdownActor',
                src: 'parseCurriculumMarkdownActor',
                input: function(param) {
                    var context = param.context;
                    return {
                        markdownContent: context.importedMarkdownContentForCurriculum,
                        parseFunction: context.dependencies.parseCurriculumMarkdown
                    };
                },
                onDone: {
                    target: 'confirmingCurriculumImport',
                    actions: assign({
                        parsedSectionsForImport: function(param) {
                            var event = param.event;
                            return event.output;
                        },
                        importedMarkdownContentForCurriculum: null,
                        errorMessage: null
                    })
                },
                onError: {
                    target: 'idle',
                    actions: [
                        assign({
                            errorMessage: '커리큘럼 마크다운 파싱 중 오류가 발생했습니다.',
                            importedMarkdownContentForCurriculum: null,
                            parsedSectionsForImport: null
                        }),
                        'notifyError'
                    ]
                }
            }
        },
        confirmingCurriculumImport: {
            entry: function(param) {
                var context = param.context;
                if (!context.parsedSectionsForImport || context.parsedSectionsForImport.length === 0) {
                    var _context_dependencies_toastError, _context_dependencies;
                    (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastError = _context_dependencies.toastError) === null || _context_dependencies_toastError === void 0 ? void 0 : _context_dependencies_toastError.call(_context_dependencies, "마크다운에서 유효한 섹션/강의 구조를 찾지 못했습니다.");
                }
            },
            on: {
                CONFIRM_CURRICULUM_IMPORT: {
                    guard: function(param) {
                        var context = param.context;
                        return !!context.parsedSectionsForImport && context.parsedSectionsForImport.length > 0;
                    },
                    actions: [
                        assign({
                            sections: function(param) {
                                var context = param.context;
                                console.log('[curriculumMachine] CONFIRM_CURRICULUM_IMPORT: Assigning parsedSectionsForImport to context.sections. Count:', context.parsedSectionsForImport.length);
                                return context.parsedSectionsForImport;
                            },
                            isCurriculumDirty: true,
                            selectedLesson: null,
                            parsedSectionsForImport: null
                        }),
                        function(param) {
                            var context = param.context;
                            var _context_dependencies_toastSuccess, _context_dependencies;
                            if (!context.dependencies || !context.dependencies.initializeSections) {
                                var _context_dependencies1;
                                console.error("Dependencies or initializeSections not available in CONFIRM_CURRICULUM_IMPORT");
                                if ((_context_dependencies1 = context.dependencies) === null || _context_dependencies1 === void 0 ? void 0 : _context_dependencies1.toastError) {
                                    context.dependencies.toastError("커리큘럼 임포트 중 내부 오류가 발생했습니다.");
                                }
                                return;
                            }
                            var importTimestamp = Date.now();
                            console.log("[curriculumMachine] CONFIRM_CURRICULUM_IMPORT: Calling dependencies.initializeSections with imported sections. Count: ".concat(context.sections.length, ", Timestamp: ").concat(importTimestamp));
                            context.dependencies.initializeSections(context.sections, context.courseId, {
                                providedTimestamp: importTimestamp,
                                markAsDirtyOnImport: true
                            });
                            (_context_dependencies = context.dependencies) === null || _context_dependencies === void 0 ? void 0 : (_context_dependencies_toastSuccess = _context_dependencies.toastSuccess) === null || _context_dependencies_toastSuccess === void 0 ? void 0 : _context_dependencies_toastSuccess.call(_context_dependencies, '커리큘럼을 성공적으로 임포트했습니다!');
                            if (context.dependencies.onCurriculumUpdated) {
                                console.log('[curriculumMachine] CONFIRM_CURRICULUM_IMPORT: Calling onCurriculumUpdated.');
                                context.dependencies.onCurriculumUpdated({
                                    isDirty: context.isCurriculumDirty,
                                    sections: context.sections,
                                    courseId: context.courseId,
                                    lectureFormDirty: context.lectureFormDirty
                                });
                            }
                        }
                    ],
                    target: 'idle'
                },
                CANCEL_CURRICULUM_IMPORT: {
                    actions: assign({
                        parsedSectionsForImport: null
                    }),
                    target: 'idle'
                }
            }
        }
    },
    on: {
        LOAD_FROM_STORE: {
            actions: [
                'applyLoadFromStoreSnapshot',
                'notifyCurriculumUpdateFromStore'
            ]
        }
    }
});
